import {
    RestServiceConfig,
    TypeTokenStorage,
} from '@common/services/rest-client/rest-client.config';

export const RestClientSettings: RestServiceConfig = {
    //authUri: '/auth/dummy',
    authUri: '/auth',
    // endPoint: '/api',
    //endPoint: 'http://localhost:10000',
    //endPoint: 'https://dev.rsav2.api.svlatam.com.mx/api',
    endPoint: 'https://recompensassuperauto.com/api',
    mockData: false,
    validationTokenUri: 'validate-token',
    UnauthorizedRedirectUri: '/',
    tokenName: 'Santander:token',
    tokenStorage: TypeTokenStorage.sessionStorage,
    // authUri: '/authenticate',
    // endPoint: '/api/v1',
};
